import React from 'react';
import { getKudosTypeById } from '../../constants/kudosTypes';
import './KudoDescriptionBubble.css';

/**
 * Reusable Kudo Description Bubble Component
 * Displays the poetic description for a kudo type on hover
 * Always sized to fit exactly 4 lines of text
 *
 * @param {string} kudoTypeId - The ID of the kudo type to display
 * @param {string} variant - 'inline' (appears next to content) or 'floating' (appears beside modal)
 * @param {string} className - Additional CSS class names
 */
const KudoDescriptionBubble = ({ kudoTypeId, variant = 'inline', className = '' }) => {
  if (!kudoTypeId) return null;

  const kudoType = getKudosTypeById(kudoTypeId);
  if (!kudoType) return null;

  return (
    <div className={`kudo-description-bubble kudo-description-bubble--${variant} ${className}`}>
      <div className="kudo-description-bubble__content">
        {kudoType.description}
      </div>
    </div>
  );
};

export default KudoDescriptionBubble;
